<template>
  <div class="custom-input">
    <div class="checkbox-item">
      <input v-model="modelValue" :id="props.id" :class="['checkbox-input', props.inputClass]" type="checkbox" />
      <label class="checkbox-label" :for="props.id">
        <span class="checkmark"></span>
        {{ props.label }}
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { defineModel, defineProps } from "vue";
  const props = withDefaults(
    defineProps<{
      id: string;
      inputClass?: string | null;
      label?: string | null;
    }>(),
    {
      inputClass: null,
      label: null
    }
  );

  const modelValue = defineModel<boolean | null | undefined>();
</script>
